require('./bootstrap')

import 'bootstrap'
import Vue from 'vue'
import './plugins/toast.js'
import './plugins/fontawesome.js'
import './plugins/progress.js'
import './plugins/gsap.js'
import './plugins/date.js'
import Layout from './Layouts/App'
import { createInertiaApp } from '@inertiajs/inertia-vue'
import AppHead from './Components/AppHead.vue'
import AppIcon from './Components/AppIcon.vue'
import BsPopover from './Components/BsPopover.vue'
import BsTooltip from './Components/BsTooltip.vue'
import SectionContainer from './Components/SectionContainer.vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import { Link } from '@inertiajs/inertia-vue'

Vue.component('AppLink', Link)
Vue.component('AppHead', AppHead)
Vue.component('AppIcon', AppIcon)
Vue.component('BsPopover', BsPopover)
Vue.component('BsTooltip', BsTooltip)
Vue.component('SectionContainer', SectionContainer)

// eslint-disable-next-line no-undef
Vue.prototype.$route = route

createInertiaApp({
    resolve: (name) => {
        const page = require(`./Pages/${name}`)
        page.layout = page.layout | Layout
        return page
    },
    setup({ el, App, props }) {
        const siteKey = props.props.initialPage.props.recaptchaSiteKey
        Vue.use(VueReCaptcha, { siteKey: siteKey })

        new Vue({
            render: (h) => h(App, props),
        }).$mount(el)
    },
})
